(function(){
  if(window.__sqSidebarTreeControllerV2)return;
  window.__sqSidebarTreeControllerV2=true;

  /* SEP 27 2026 tree behaviour on department-root rails (departments, series and State Guard state pages):
     - Categories is permanently open.
     - Click the + (or -) beside a category / subcategory to expand or collapse it in place. Any number of
       branches can be open at once.
     - Click the category / subcategory NAME to go to that page. The tree remembers the trail, and on the
       next page the same branch re-opens with the current page highlighted.
     - Links are identified by path PLUS routing params (sg_* for State Guard, sq_bfl_* for series), because
       State Guard categories / subcategories / types all live on one collection URL.
     - Keyboard: Space toggles a branch, Enter follows the link. */

  function boot(){
    var rail=document.querySelector('[data-sq-collection-rail][data-sq-department-root="true"]');
    if(!rail)return;
    rail.classList.add('sq-inline-accordion','sq-tree-controller-v2');

    var mobileToggle=rail.querySelector('[data-sq-rail-mobile-toggle]');
    var overlay=rail.querySelector('[data-sq-rail-overlay]');
    var pending=null;
    var restoring=false,restored=false;

    function categoriesItem(){return rail.querySelector('[data-sq-context-categories]')}
    function categoriesList(){return rail.querySelector('[data-sq-context-categories-list]')}
    function isCategories(item){return !!item&&item.hasAttribute('data-sq-context-categories')}
    function topItems(){return Array.prototype.slice.call(rail.querySelectorAll('[data-sq-rail-menu-item]:not([hidden])'))}
    function triggerOf(item){return item&&item.querySelector(':scope > [data-sq-rail-trigger]')}
    function keyParams(u){var out=[];u.searchParams.forEach(function(v,k){if(v&&/^(sg_|sq_bfl_)/.test(k))out.push(k+'='+v)});out.sort();return out}
    function cleanPath(u){return u.pathname.toLowerCase().replace(/\/+$/,'')}
    function pathKey(href){try{var u=new URL(href,location.origin),q=keyParams(u);return cleanPath(u)+(q.length?'?'+q.join('&'):'')}catch(_){return''}}
    /* true when the link points at the current page or at a parent of it (its routing params are a subset of the
       current page's, or it is the parent collection of a tag-filtered child page). */
    function containsHere(href){
      try{
        var u=new URL(href,location.origin),h=new URL(location.href),up=cleanPath(u),hp=cleanPath(h),lq=keyParams(u),hq=keyParams(h);
        if(up!==hp){return !lq.length&&!hq.length&&hp.indexOf(up+'/')===0}
        if(!lq.length)return !hq.length;
        return lq.every(function(x){return hq.indexOf(x)!==-1});
      }catch(_){return false}
    }
    function trailKey(){return 'sqTreeTrail:'+(rail.dataset.sqPersistentRoot||rail.dataset.collectionHandle||'root')}
    function clearTreeInside(item){
      if(!item)return;
      item.querySelectorAll('a.is-cascade-active').forEach(function(a){a.classList.remove('is-cascade-active');a.setAttribute('aria-expanded','false')});
      item.querySelectorAll('.sq-collection-rail__cascade-column').forEach(function(panel){panel.hidden=true});
    }
    function setTop(item,open){
      if(!item)return;
      if(isCategories(item))open=true;
      if(!open)clearTreeInside(item);
      if(item.classList.contains('is-open')!==!!open)item.classList.toggle('is-open',!!open);
      var t=triggerOf(item);if(t&&t.getAttribute('aria-expanded')!==(open?'true':'false'))t.setAttribute('aria-expanded',open?'true':'false');
    }
    function closeTop(except){
      topItems().forEach(function(item){if(item!==except&&!isCategories(item))setTop(item,false)});
      rail.classList.remove('sq-collection-rail--flyout-open');
      if(overlay)overlay.hidden=true;
    }
    function toggleTop(item){
      if(isCategories(item)){keepCategoriesOpen();return}
      var open=item.classList.contains('is-open');
      closeTop(item);
      setTop(item,!open);
    }
    function directNestedPanel(li){
      if(!li)return null;
      for(var i=0;i<li.children.length;i++){
        var el=li.children[i];
        if(el.classList&&el.classList.contains('sq-collection-rail__cascade-column'))return el;
      }
      return null;
    }
    function collapseBranch(a){
      if(!a)return;
      a.classList.remove('is-cascade-active');
      a.setAttribute('aria-expanded','false');
      var li=a.closest('li'),panel=directNestedPanel(li);
      if(panel)panel.hidden=true;
    }
    function api(){
      var apis=window.__sqSidebarTreeDataApis||{};
      if(rail.dataset.sqStateGuardComponentRoot==='true')return apis['state-guard']||null;
      return apis.generic||window.__sqSidebarTreeDataApi||null
    }
    function branchKind(a){
      if(!a)return'';
      if(a.dataset.sqCascadeKind==='type'||a.dataset.sqCascadeKind==='direct-type'||a.dataset.kind==='type')return'';
      if(a.dataset.sqCascadeKind==='subcategory'||a.dataset.kind==='subcategory')return'subcategory';
      var catList=categoriesList();
      var li=a.closest('li');
      if(catList&&li&&li.parentElement===catList)return'category';
      return'';
    }
    function keepCategoriesOpen(){
      var catItem=categoriesItem();
      if(!catItem)return;
      if(!catItem.classList.contains('is-open'))catItem.classList.add('is-open');
      var t=triggerOf(catItem);
      if(t&&t.getAttribute('aria-expanded')!=='true')t.setAttribute('aria-expanded','true');
    }
    /* The + / - sits in the link's left padding. A click there toggles; a click on the name navigates. */
    function inPlusZone(e,a){
      if(!e||e.detail===0)return false;
      try{
        var r=a.getBoundingClientRect(),pad=parseFloat(getComputedStyle(a).paddingLeft)||40;
        return (e.clientX-r.left)<=Math.max(pad,30);
      }catch(_){return false}
    }

    /* ---------- trail memory ---------- */
    function categoryLinkFor(el){
      var catList=categoriesList();if(!catList||!el)return null;
      var li=el.closest('li');
      while(li&&li.parentElement!==catList){var up=li.parentElement;li=up?up.closest('li'):null}
      return li?li.querySelector(':scope > a[href]'):null;
    }
    function subcategoryLinkFor(el,kind){
      if(kind==='subcategory')return el;
      var typesPanel=el.closest('[data-sq-cascade-types]');
      if(!typesPanel)return null;
      var li=typesPanel.parentElement&&typesPanel.parentElement.closest('li');
      return li?li.querySelector(':scope > a[href]'):null;
    }
    function saveTrail(clicked,kind){
      var catItem=categoriesItem();
      if(!catItem||!catItem.contains(clicked))return;
      var catA=kind==='category'?clicked:categoryLinkFor(clicked);
      var subA=kind==='category'?null:subcategoryLinkFor(clicked,kind);
      var trail={cat:catA?catA.getAttribute('href'):'',sub:subA?subA.getAttribute('href'):'',leaf:clicked.getAttribute('href')||''};
      try{sessionStorage.setItem(trailKey(),JSON.stringify(trail))}catch(_){}
    }
    function loadTrail(){
      try{var t=JSON.parse(sessionStorage.getItem(trailKey())||'null');return t&&typeof t==='object'?t:null}catch(_){return null}
    }
    function findIn(root,href){
      if(!root||!href)return null;
      var want=pathKey(href),links=root.querySelectorAll('a[href]');
      for(var i=0;i<links.length;i++){if(pathKey(links[i].getAttribute('href'))===want)return links[i]}
      return null;
    }
    function isSubLink(a){return a&&(a.dataset.sqCascadeKind==='subcategory'||a.dataset.kind==='subcategory')}
    function markCurrent(){
      var catItem=categoriesItem();if(!catItem)return;
      var here=pathKey(location.href),best=null;
      catItem.querySelectorAll('a[href]').forEach(function(a){
        if(a.closest('.sq-collection-rail__cascade-column[hidden]'))return;
        var k=pathKey(a.getAttribute('href'));
        if(k===here){
          if(!best||a.dataset.sqCascadeKind==='type'||a.dataset.sqCascadeKind==='subcategory'||a.dataset.kind==='type'||a.dataset.kind==='subcategory')best=a;
        }
      });
      catItem.querySelectorAll('a.sq-tree-current').forEach(function(a){if(a!==best){a.classList.remove('sq-tree-current');if(a.getAttribute('aria-current')==='page')a.removeAttribute('aria-current')}});
      if(best){
        best.classList.add('sq-tree-current');
        if(best.getAttribute('aria-current')!=='page')best.setAttribute('aria-current','page');
        var nav=rail.querySelector('.sq-collection-rail__nav');
        if(nav&&!best.dataset.sqScrolled){
          best.dataset.sqScrolled='1';
          try{var nr=nav.getBoundingClientRect(),br=best.getBoundingClientRect();if(br.top<nr.top||br.bottom>nr.bottom)nav.scrollTop+=br.top-nr.top-nr.height/3}catch(_){}
        }
      }
    }
    function restoreTrail(){
      if(restored||restoring)return;
      var catItem=categoriesItem(),catList=categoriesList(),x=api();
      if(!catItem||!catList||!catList.querySelector('a[href]')||!x)return;
      var here=pathKey(location.href),trail=loadTrail(),catA=null,subHref='';
      if(trail){
        var keys=[trail.cat,trail.sub,trail.leaf].filter(Boolean).map(pathKey);
        if(keys.indexOf(here)!==-1){catA=findIn(catList,trail.cat);subHref=trail.sub||''}
      }
      if(!catA){
        var links=catList.querySelectorAll(':scope > li > a[href]');
        for(var i=0;i<links.length;i++){if(containsHere(links[i].getAttribute('href'))){catA=links[i];break}}
      }
      restored=true;
      if(!catA){markCurrent();return}
      restoring=true;
      keepCategoriesOpen();
      Promise.resolve(x.activateCategory(catA)).then(function(){
        keepCategoriesOpen();stabilizeActiveTree();
        var host=catA.closest('li'),panel=host&&host.querySelector(':scope > [data-sq-cascade-subcategories]');
        var subA=subHref?(findIn(panel,subHref)||findIn(catItem.querySelector('[data-sq-cascade-subcategories]'),subHref)):null;
        if(!subA&&panel){
          var catKey=pathKey(catA.getAttribute('href')),cands=panel.querySelectorAll(':scope > ul > li > a[href]');
          for(var j=0;j<cands.length;j++){if(isSubLink(cands[j])&&pathKey(cands[j].getAttribute('href'))!==catKey&&containsHere(cands[j].getAttribute('href'))){subA=cands[j];break}}
        }
        if(!subA||!isSubLink(subA))return;
        return Promise.resolve(x.activateSubcategory(subA)).then(function(){keepCategoriesOpen();stabilizeActiveTree()});
      }).catch(function(){}).then(function(){restoring=false;markCurrent()});
    }

    function activateBranch(a,kind){
      var x=api();
      if(!x){pending={a:a,kind:kind};return}
      var result;
      try{result=kind==='category'?x.activateCategory(a):x.activateSubcategory(a)}catch(_){return}
      Promise.resolve(result).then(function(){keepCategoriesOpen();stabilizeActiveTree();markCurrent()}).catch(function(){});
    }
    function toggleBranch(a,kind){
      keepCategoriesOpen();
      if(a.classList.contains('is-cascade-active')){collapseBranch(a);return}
      activateBranch(a,kind);
      [40,180,650].forEach(function(ms){window.setTimeout(function(){keepCategoriesOpen();stabilizeActiveTree()},ms)});
    }
    function stripLegacyGeometry(){
      rail.querySelectorAll('.sq-collection-rail__flyout').forEach(function(el){
        ['top','right','bottom','left','width','height'].forEach(function(p){if(el.style.getPropertyValue(p))el.style.removeProperty(p)});
      });
      rail.querySelectorAll('.sq-collection-rail__flyout-inner').forEach(function(el){
        ['width','height','padding-top'].forEach(function(p){if(el.style.getPropertyValue(p))el.style.removeProperty(p)});
      });
    }
    function stabilizeActiveTree(){
      var catItem=categoriesItem();
      if(!catItem)return;
      keepCategoriesOpen();
      catItem.querySelectorAll('a.is-cascade-active').forEach(function(a){
        var panel=directNestedPanel(a.closest('li'));
        if(panel&&panel.hidden)panel.hidden=false;
      });
    }

    rail.addEventListener('click',function(e){
      var t=e.target.closest&&e.target.closest('[data-sq-rail-trigger]');
      if(t&&rail.contains(t)){
        var item=t.closest('[data-sq-rail-menu-item]');
        if(item){e.preventDefault();e.stopImmediatePropagation();toggleTop(item);stripLegacyGeometry();return}
      }
      var a=e.target.closest&&e.target.closest('a[href]');
      if(a&&rail.contains(a)){
        if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
        var kind=branchKind(a);
        if(kind&&inPlusZone(e,a)){
          e.preventDefault();e.stopImmediatePropagation();
          toggleBranch(a,kind);stripLegacyGeometry();return;
        }
        saveTrail(a,kind);
        if(kind){e.stopImmediatePropagation();return}
      }
      if(e.target===overlay){e.preventDefault();e.stopImmediatePropagation();closeTop()}
    },true);

    rail.addEventListener('pointerover',function(e){if(e.target.closest&&e.target.closest('[data-sq-rail-menu-item]'))e.stopImmediatePropagation()},true);
    rail.addEventListener('pointerout',function(e){if(e.target.closest&&e.target.closest('[data-sq-rail-menu-item]'))e.stopImmediatePropagation()},true);
    rail.addEventListener('focusin',function(e){if(e.target.closest&&e.target.closest('[data-sq-rail-menu-item]'))e.stopImmediatePropagation()},true);
    rail.addEventListener('focusout',function(e){if(e.target.closest&&e.target.closest('[data-sq-rail-menu-item]'))e.stopImmediatePropagation()},true);

    rail.addEventListener('keydown',function(e){
      var a=e.target.closest&&e.target.closest('a[href]');
      var kind=branchKind(a);
      if(kind&&e.key===' '){e.preventDefault();toggleBranch(a,kind);return}
      if(e.key==='Escape'){closeTop()}
    },true);

    if(mobileToggle)mobileToggle.addEventListener('click',function(e){
      e.preventDefault();e.stopImmediatePropagation();
      var open=rail.classList.toggle('sq-collection-rail--mobile-open');
      mobileToggle.setAttribute('aria-expanded',open?'true':'false');
      if(!open)closeTop();
    },true);

    window.addEventListener('sq:sidebar-tree-data-ready',function(e){
      var needed=rail.dataset.sqStateGuardComponentRoot==='true'?'state-guard':'generic';
      if(e&&e.detail&&e.detail.mode&&e.detail.mode!==needed)return;
      if(pending){var p=pending;pending=null;activateBranch(p.a,p.kind)}
      restoreTrail();
    });

    var mo=new MutationObserver(function(){stripLegacyGeometry();stabilizeActiveTree();if(!restored)restoreTrail()});
    mo.observe(rail,{subtree:true,childList:true});
    stripLegacyGeometry();stabilizeActiveTree();restoreTrail();
    [100,300,800,1600,3200].forEach(function(ms){setTimeout(function(){stripLegacyGeometry();stabilizeActiveTree();if(!restored)restoreTrail();else if(!restoring)markCurrent()},ms)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
